import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { IDomaine } from "../../cdsApiSlice";

interface IImpossibleDomaineRemove {
  setter: () => void;
  domaine: IDomaine;
  displayComponent: boolean;
}

const DomainNotDeletable = ({
  setter,
  domaine,
  displayComponent,
}: IImpossibleDomaineRemove) => {
    
  const footerDialog = () => {
    <Button
      label={"ANNULER"}
      disabled={false}
      onClick={() => setter()}
      className="p-button p-button-sm"
    />;
  };

  return (
    <>
      <Dialog
        header={`Suppression impossible`}
        footer={footerDialog}
        visible={displayComponent}
        style={{ width: "25vw" }}   
        modal
        onHide={() => {
          setter();
        }}
      >
        <div className="mb-3">
          la suppresion du domaine{" "}
          <span className="font-bold">{domaine.libelle}</span> est impossible.
        </div>

        <div>Il contient {domaine.sourcesCount} sources</div>
        <ul>
          {domaine.sources?.map((i) => (
            <li className="font-bold">{i.nom}</li>
          ))}
        </ul>
      </Dialog>
    </>
  );
};

export default DomainNotDeletable;
